<app-horizontal-wrapper [label]="label" [required]="required()" [alignRight]="alignRight">
  <div style="position: relative">
    <div
      *ngIf="modal == true"
      (click)="open(content)"
      style="position: absolute; z-index: 99; right: 5px; top: 12px"
    >
      <i class="fa-solid fa-circle-info text-primary me-2" title="Meer info over dit veld"></i>
    </div>
    @if (readOnly) {
      <div [innerHTML]="control.value"></div>
    } @else {
      <div style="z-index: -1">
        <editor
          [init]="config"
          [id]="id"
          [formControl]="control"
          #editor
          (onKeyDown)="handleKeyDown($event.event, $event.editor)"
        >
        </editor>
      </div>
    }
    <app-validator [control]="control" [label]="label"></app-validator>
  </div>
</app-horizontal-wrapper>

<ng-template #content let-modal>
  <app-modal>
    <ng-container modal-title>{{ modalTitle }}</ng-container>
    <ng-container modal-body><ng-content></ng-content></ng-container>
  </app-modal>
</ng-template>
